import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLang } from '../LanguageContext';
import './Navbar.css';

const NAV_ITEMS = [
  ['about',    { ko: '회사소개', en: 'About' }],
  ['products', { ko: '제품소개', en: 'Products' }],
  ['service',  { ko: '서비스',   en: 'Service' }],
  ['qna',      { ko: 'Q&A',      en: 'Q&A' }],
  ['notice',   { ko: '공지사항', en: 'Notice' }],
  ['contact',  { ko: '문의하기', en: 'Contact' }],
];

function Navbar({ currentSection, onNavigate, sectionIds }) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { lang, setLang } = useLang();
  const isMainPage = location.pathname === '/';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleClick = (e, id) => {
    e.preventDefault();
    setMenuOpen(false);
    if (isMainPage) {
      const index = sectionIds.indexOf(id);
      if (index >= 0 && onNavigate) {
        onNavigate(index);
        // URL에서 해시 제거
        window.history.replaceState(null, '', '/');
      }
    } else {
      // 다른 페이지에서 메인으로 이동 - 세션에 목표 섹션 저장 후 이동
      sessionStorage.setItem('scrollTo', id);
      navigate('/');
    }
  };

  return (
    <nav className={`navbar ${scrolled || !isMainPage ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <a href="/" className="logo" onClick={(e) => {
          e.preventDefault();
          if (isMainPage) {
            const index = sectionIds.indexOf('hero');
            if (index >= 0 && onNavigate) onNavigate(index);
          } else {
            navigate('/');
          }
        }}>
          <img src="/medilogis_logo.png" alt="MEDILOGIS" className="logo-mark" />
          <span className="logo-text">MEDI<span>LOGIS</span></span>
        </a>
        <button
          className={`nav-toggle ${menuOpen ? 'active' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label={menuOpen ? '메뉴 닫기' : '메뉴 열기'}
        >
          <span></span><span></span><span></span>
        </button>
        {menuOpen && <div className="nav-backdrop" onClick={() => setMenuOpen(false)} />}
        <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
          {NAV_ITEMS.map(([id, label]) => (
            <li key={id}>
              {id === 'notice' ? (
              <a href="/notice" onClick={(e) => { e.preventDefault(); setMenuOpen(false); navigate('/notice'); }}>{label[lang]}</a>
              ) : (
              <a
                href={`/#${id}`}
                className={isMainPage && sectionIds && sectionIds[currentSection] === id ? 'active' : ''}
                onClick={(e) => handleClick(e, id)}
              >
                {label[lang]}
              </a>
              )}
            </li>
          ))}
          <li className="lang-toggle-li">
            <button
              type="button"
              className="lang-toggle"
              onClick={() => setLang(lang === 'ko' ? 'en' : 'ko')}
              aria-label="Language"
            >
              <span className={lang === 'ko' ? 'active' : ''}>KO</span>
              <span className="sep">|</span>
              <span className={lang === 'en' ? 'active' : ''}>EN</span>
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
